'use client';

const KEY = 'jvu:recently-viewed';
const EVENT = 'jvu:recently-viewed';
const LIMIT = 8;

// Per-browser convenience only; failures (private mode, blocked storage) simply hide the section.
function read(): string {
  try {
    return window.localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

export function parseRecent(raw: string): string[] {
  return raw
    .split(',')
    .filter((slug) => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug))
    .slice(0, LIMIT);
}

export function subscribeRecent(notify: () => void) {
  window.addEventListener('storage', notify);
  window.addEventListener(EVENT, notify);
  return () => {
    window.removeEventListener('storage', notify);
    window.removeEventListener(EVENT, notify);
  };
}

export const getRecentSnapshot = read;
export const getRecentServerSnapshot = () => '';

export function rememberViewed(slug: string) {
  const next = [slug, ...parseRecent(read()).filter((item) => item !== slug)]
    .slice(0, LIMIT)
    .join(',');
  try {
    window.localStorage.setItem(KEY, next);
  } catch {
    return;
  }
  window.dispatchEvent(new Event(EVENT));
}
